import { createContext, useContext } from 'react';
import { EnrichedSettingsTreeDto } from './settings-tree-reducer.types';
import { useSettingsTreeReducer } from './settings-tree.reducer';

const SettingsTreeReducerContext = createContext<ReturnType<typeof useSettingsTreeReducer>>(undefined!);

export const SettingsTreeReducerProvider = (props: {
  children: React.ReactNode;
  settingsTreeDto: EnrichedSettingsTreeDto;
}) => {
  const value = useSettingsTreeReducer(props.settingsTreeDto);
  return <SettingsTreeReducerContext.Provider value={value} {...props} />;
};

export const useSettingsTreeReducerContext = () => {
  return useContext(SettingsTreeReducerContext);
};
